module.exports = __webpack_public_path__ + "static/media/audioJgd.528dc617.mpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/audioJgd.mpeg
// module id = 244
// module chunks = 0